import React, { Component } from 'react';
import { Fieldset } from 'primereact/fieldset';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Buscar, Atualizar } from '../../services/perfis';
import { Card } from 'primereact/card';
import fundo_amarelo from '../../assets/fundo_amarelo.png';
import * as moment from 'moment';
import { decriptoLocalStorage } from '../../modulos/cripotografia/criptoStorage';

class EditarPerfil extends Component {
    constructor() {
        super();
        this.state = {
            Nome: '',
            Telefone: '',
            Email: '',
            Nascimento: '',
            Endereco: '',
            CEP: '',
            Cidade: '',
            Estado: '',
            RG: '',
            CPF: '',
            CNH: '',
            CTPS: '',
            Banco: '',
            Agencia: '',
            Conta: '',
            idade: '',
            submit: true,
            loading: 'nada'
        };
        this.handleForm = this.handleForm.bind(this);
    }

    componentDidMount() {
        Buscar(this.state.cod)
            .then(response => {
                const data1 = moment(response.Nascimento).add(3, 'hours').format('YYYY');
                const data2 = new Date().getFullYear();
                const idade = (data2 - data1);

                this.setState({
                    cod: decriptoLocalStorage('codigo_vendedor')?.decriptoValue,
                    Nome: response.Nome !== null ? response.Nome : '',
                    Telefone: response.Telefone !== null ? response.Telefone : '',
                    Email: response.Email !== null ? response.Email : '',
                    Nascimento: response.Nascimento !== null ? response.Nascimento : '',
                    Endereco: response.Endereco !== null ? response.Endereco : '',
                    CEP: response.CEP !== null ? response.CEP : '',
                    Cidade: response.Nome_cidade !== null ? response.Nome_cidade : '',
                    Estado: response.estado !== null ? response.estado : '',
                    RG: response.RG !== null ? response.RG : '',
                    CPF: response.CPF !== null ? response.CPF : '',
                    CNH: response.CNH !== null ? response.CNH : '',
                    CTPS: response.CarteiraTrabalho !== null ? response.CarteiraTrabalho : '',
                    Banco: response.Banco !== null ? response.Banco : '',
                    Agencia: response.Agencia !== null ? response.Agencia : '',
                    Conta: response.Conta !== null ? response.Conta : '',
                    idade: response.Nascimento !== null ? idade : '',
                    loading: 'loading',
                    submit: false
                });
            }).catch(erro => {
                this.setState({
                    loading: 'loading',
                    submit: true
                });
            });
    }

    AtualizarDados = () => {
        this.setState({
            loading: 'nada',
            submit: true
        });
        window.scrollTo(0, 0);

        const dados = this.state;

        Atualizar(dados).then(response => {
            if (response.status === 200) {
                setTimeout(() => {
                    this.setState({
                        loading: 'loading',
                        submit: false
                    });
                    this.props.history.push('/home');
                    window.location.reload();
                }, 2000);
            }

            if (response.status === 400) {
                setTimeout(() => {
                    this.setState({
                        loading: 'loading',
                        submit: false
                    });
                    alert('ops, estamos tendo problemas para validadr seus dados');
                }, 2000);
            }
        }).catch(function (erro) {
            this.setState({
                loading: 'loading',
                submit: false
            });
        });
    }

    handleForm = e => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    render() {
        const header = <img alt="Card" src={fundo_amarelo} />;

        return (
            <Card className='tratar-scroll-card' header={header} title="Editar Perfil">

                <div className={this.state.loading}>
                    <ProgressSpinner
                        style={{
                            width: '300px',
                            height: '150px',
                            display: 'flex',
                            margin: '0 auto',
                            marginTop: '8%'
                        }}
                        strokeWidth="1"
                        fill="#EEEEEE"
                        animationDuration=".5s"
                    />
                </div>

                {this.state.submit !== true &&
                    <div className="content-section implementation">
                        <Fieldset legend="Dados Pessoais">
                            <div className="p-grid p-fluid" >
                                <div className="p-col-12 p-md-8">
                                    <div className="p-field p-grid">
                                        <label htmlFor="Nome" className="p-col-fixed" style={{ width: '50px' }}>Nome</label>
                                        <div className="p-col">
                                            <InputText placeholder="Nome" name="Nome" id="Nome" value={this.state.Nome} onChange={e => this.handleForm(e)} />
                                        </div>
                                    </div>
                                </div>

                                <div className="p-col-12 p-md-4">
                                    <div className="p-field p-grid">
                                        <label htmlFor="Telefone" className="p-col-fixed" style={{ width: '60px' }}>Telefone</label>
                                        <div className="p-col">
                                            <InputText name="Telefone" id="Telefone" value={this.state.Telefone} onChange={e => this.handleForm(e)} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="p-grid p-fluid" >
                                <div className="p-col-12 p-md-8">
                                    <div className="p-field p-grid">
                                        <label htmlFor="Email" className="p-col-fixed" style={{ width: '50px' }}>Email</label>
                                        <div className="p-col">
                                            <InputText name="Email" id="Email" value={this.state.Email} onChange={e => this.handleForm(e)} disabled={true} />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <div className="p-field p-grid">
                                        <label htmlFor="Idade" className="p-col-fixed" style={{ width: '60px' }}>Idade</label>
                                        <div className="p-col">
                                            <InputText name="Idade" id="Idade" value={`${this.state.idade} anos`} onChange={e => this.handleForm(e)} disabled={true} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </Fieldset>
                        <br />
                        <Fieldset legend="Endereço" >
                            <div className="p-grid p-fluid" >
                                <div className="p-col-12 p-md-9">
                                    <div className="p-field p-grid">
                                        <label htmlFor="Endereco" className="p-col-fixed" style={{ width: '70px' }}>Endereco</label>
                                        <div className="p-col">
                                            <InputText name="Endereco" id="Endereco" value={this.state.Endereco} onChange={e => this.handleForm(e)} />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <div className="p-field p-grid">
                                        <label htmlFor="CEP" className="p-col-fixed" style={{ width: '35px' }}>CEP</label>
                                        <div className="p-col">
                                            <InputText name="CEP" id="CEP" value={this.state.CEP} onChange={e => this.handleForm(e)} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="p-grid p-fluid" >
                                <div className="p-col-12 p-md-8">
                                    <div className="p-field p-grid">
                                        <label htmlFor="Cidade" className="p-col-fixed" style={{ width: '70px' }}>Cidade</label>
                                        <div className="p-col">
                                            <InputText name="Cidade" id="Cidade" value={this.state.Cidade} onChange={e => this.handleForm(e)} />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <div className="p-field p-grid">
                                        <label htmlFor="Estado" className="p-col-fixed" style={{ width: '55px' }}>Estado</label>
                                        <div className="p-col">
                                            <InputText name="Estado" id="Estado" value={this.state.Estado} onChange={e => this.handleForm(e)} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Fieldset>
                        <br />
                        <Fieldset legend="Documentos">
                            <div className="p-grid p-fluid" >
                                <div className="p-col-12 p-md-6">
                                    <div className="p-field p-grid">
                                        <label htmlFor="RG" className="p-col-fixed" style={{ width: '40px' }}>RG</label>
                                        <div className="p-col">
                                            <InputText name="RG" id="RG" value={this.state.RG} onChange={e => this.handleForm(e)} />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-6">
                                    <div className="p-field p-grid">
                                        <label htmlFor="CNH" className="p-col-fixed" >CNH</label>
                                        <div className="p-col">
                                            <InputText placeholder="CNH" name="CNH" id="CNH" value={this.state.CNH} onChange={e => this.handleForm(e)} />
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div className="p-grid p-fluid" >
                                <div className="p-col-12 p-md-6">
                                    <div className="p-field p-grid">
                                        <label htmlFor="CPF" className="p-col-fixed" style={{ width: '40px' }}>CPF</label>
                                        <div className="p-col">
                                            <InputText placeholder="CPF" name="CPF" id="CPF" value={this.state.CPF} onChange={e => this.handleForm(e)} disabled={true} />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-6">
                                    <div className="p-field p-grid">
                                        <label htmlFor="CTPS" className="p-col-fixed" style={{ width: '40px' }}>CTPS</label>
                                        <div className="p-col">
                                            <InputText name="CTPS" id="CTPS" value={this.state.CTPS} onChange={e => this.handleForm(e)} disabled={this.state.submit} />
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </Fieldset>
                        <br />
                        <Fieldset legend="Dados bancários">
                            <div className="p-grid p-fluid" >
                                <div className="p-col-12 p-md-4">
                                    <div className="p-field p-grid">
                                        <label htmlFor="Banco" className="p-col-fixed" style={{ width: '50px' }}>Banco</label>
                                        <div className="p-col">
                                            <InputText type="number" name="Banco" id="Banco" value={this.state.Banco} onChange={e => this.handleForm(e)} maxLength={3} />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <div className="p-field p-grid">
                                        <label htmlFor="Agencia" className="p-col-fixed" style={{ width: '60px' }}>Agencia</label>
                                        <div className="p-col">
                                            <InputText name="Agencia" id="Agencia" value={this.state.Agencia} onChange={e => this.handleForm(e)} maxLength={4} />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <div className="p-field p-grid">
                                        <label htmlFor="Conta" className="p-col-fixed" style={{ width: '50px' }}>Conta</label>
                                        <div className="p-col">
                                            <InputText name="Conta" id="Conta" value={this.state.Conta} onChange={e => this.handleForm(e)} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Fieldset>
                        <br />
                        <Button label="Atualizar dados" onClick={() => { this.AtualizarDados(); }} />
                    </div>}
            </Card>
        );
    }
}

export default EditarPerfil;
